import { NftSort, StatusFilterOption } from "./types"

export const DEFAULT_SORT = NftSort.LOW_PRICE_FIRST
export const DEFAULT_PAGE_SIZE = 35
export const DEFAULT_STATUS = StatusFilterOption.ALL
